import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const CategoriesSection = () => {


  return (
    <section className="categories-area section-py-50 mr-t-b-60">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-7">
            <div className="section__title text-center mb-40">
              <span className="sub-title">Growth Zone</span>
              <h2 className="title">Explore Programs by Category</h2>
              <p className="desc">Find the right program for your career growth</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="categories__wrap">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  nextEl: '.categories-button-next',
                  prevEl: '.categories-button-prev',
                }}
                spaceBetween={20}
                slidesPerView={5}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                  },
                  576: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  992: {
                    slidesPerView: 5,
                  },
                }}
                className="categories-active"
              >
                {[
                  { icon: 'flaticon-graphic-design', name: 'Graphic Design' },
                  { icon: 'flaticon-investment', name: 'Finance' },
                  { icon: 'flaticon-coding', name: 'Development' },
                  { icon: 'flaticon-email', name: 'Marketing' },
                  { icon: 'flaticon-interaction', name: 'Management' },
                  { icon: 'flaticon-web-design', name: 'App Design' },
                ].map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="categories__item">
                      <a href="/programs">
                        <div className="icon">
                          <i className={item.icon}></i>
                        </div>
                        <span className="name">{item.name}</span>
                      </a>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="categories__nav">
                <button className="categories-button-prev text-white">
                  {"<-"}
                </button>
                <button className="categories-button-next text-white">
                  {"->"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



  );
};

export default CategoriesSection;